import {create} from 'zustand';
export const useDealsStore = create((set) => ({
    deals: null,
    deal: null,
    setDeals: (deals) => set({ deals }),
    setDeal: (deal) => set({ deal }),
}));